module.exports = __webpack_public_path__ + "@/assets/img/cards_teclab.2db006b9.png";